import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export default function CategoryBannerSlider({ banners = [] }) {
  const validBanners = banners.filter((banner) => banner.image);
  const swiperRef = useRef(null);

  if (!validBanners.length) return null;

  const canLoop = validBanners.length >= 3;

  const handleSlideChange = (swiper) => {
    const activeBanner = validBanners[swiper.realIndex];
    if (activeBanner?.banner_type === "video") {
      swiper.autoplay.stop();
    } else {
      swiper.autoplay.start();
    }
  };

  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      slidesPerView={1}
      loop={canLoop}
      observer={true}
      observeParents={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      pagination={{ clickable: true }}
      className="mb-8 w-full overflow-hidden"
      style={{ width: "100%" }}
      onSwiper={(swiper) => (swiperRef.current = swiper)}
      onSlideChange={handleSlideChange}
    >
      {validBanners.map((banner, index) => (
        <SwiperSlide key={banner.id ?? index} className="!w-full">
          <div className="relative w-full h-[250px] md:h-[450px] overflow-hidden">
            {banner.banner_type === "video" ? (
              <video
                src={banner.image}
                autoPlay
                muted
                loop
                playsInline
                onEnded={() => swiperRef.current?.autoplay?.start()}
                className="w-full h-full object-contain rounded"
              />
            ) : (
              <img
                src={banner.image}
                alt=""
                className="w-full h-full object-cover rounded"
              />
            )}
            <div className="absolute inset-0 pointer-events-none" />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
